import React, { useEffect } from "react"
import "./index.less"
import { quote_item_trade_info, quote_trade_info } from "../../shared/quotedata/index"
import { store } from "./store"
import { Observer } from "mobx-react-lite"
import { quotedata } from "../../shared/quotedata"
import { checkIP, getCookie, QuoteTradeRecord } from "../../shared/utils"

export function HKTimeTrade(props: { quotedata: quotedata }) {
  let isCN = checkIP()

  useEffect(() => {
    if (isCN) {
      // 判断用户是否登录
      if (getCookie("uidal") != null && getCookie("uidal") != undefined && getCookie("uidal") != "") {
        // 十档行情
        store.setQuoteTradeType(QuoteTradeRecord.十档行情)
      } else {
        // if ((store.StockDetail && parseInt(store.StockDetail.f177)) & (128 | 256 | 512 | 1024)) {
        //   // 一档行情
        //   store.setQuoteTradeType(QuoteTradeRecord.零档行情)
        // } else {
          // 0档行情
          store.setQuoteTradeType(QuoteTradeRecord.零档行情)
        // }
      }
    } else {
      // 0档行情
      store.setQuoteTradeType(QuoteTradeRecord.零档行情)
    }
  }, [])
  
  return (
    <Observer>
      {() => (
        <>
          {store.QuoteTradeType == QuoteTradeRecord.十档行情 && store.StockDetail && <TenSellAndBuy />}
          {store.QuoteTradeType == QuoteTradeRecord.一档行情 && store.StockDetail && <OneSellAndBuy />}
          {store.QuoteTradeType == QuoteTradeRecord.零档行情 && <ZeroSellAndBuy />}
        </>
      )}
    </Observer>
  )
}

// 十档行情
function TenSellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖9</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖9价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖9量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖8</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖8价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖8量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖7</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖7价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖7量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖6</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖6价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖6量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖5</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖5价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖5量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖4</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖4价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖4量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖3</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖3价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖3量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖2</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖2价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖2量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>卖1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).hk_element}
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买2</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买2价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买2量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买3</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买3价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买3量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买4</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买4价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买4量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买5</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买5价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买5量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买6</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买6价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买6量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买7</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买7价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买7量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买8</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买8价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买8量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买9</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买9价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买9量](store.StockDetail).hk_element}
        </li>
      </ul>
    </>
  )
}

// 一档行情
function OneSellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.卖1价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.卖1量](store.StockDetail).hk_element}
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>&nbsp;
          {quote_trade_info[quote_item_trade_info.买1价](store.StockDetail).hk_element}
          {quote_trade_info[quote_item_trade_info.买1量](store.StockDetail).hk_element}
        </li>
        <li>
          <span>买2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
      </ul>
    </>
  )
}

// 零档行情
function ZeroSellAndBuy() {
  return (
    <>
      <ul className="tb-sell">
        <li>
          <span>卖5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>卖1</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
      </ul>
      <ul className="tb-buy">
        <li>
          <span>买1</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买2</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买3</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买4</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
        <li>
          <span>买5</span>&nbsp;
          <span>-</span>
          <span>-</span>
        </li>
      </ul>
    </>
  )
}
